import React from "react";

const Colors = () => {
  return (
    <div>
      <fieldset className="border-dashed flex items-center rounded-[48px] border-(--white-10) border">
        <legend className="ml-12 bg-(--white-05) max-w-fit font-bold py-2 px-4 rounded-full text-(--information) mt-4">
          Primary Colors
        </legend>
        <div className="flex flex-col w-full p-4 justify-between gap-4">
          <div className=" w-1/5  bg-gradient p-4 flex justify-center rounded-lg">
            Primary gradient
          </div>
          <div className=" w-1/5 p-4 flex justify-center rounded-lg border-solid border border-(--white-10)">
            <span className="clipped">Gradient Text</span>
          </div>
          <div className=" w-1/5  bg-white text-black p-4 flex justify-center rounded-lg">
            White
          </div>
          <div className=" w-1/5  bg-(--information) p-4 flex justify-center rounded-lg">
            Information
          </div>
          <div className=" w-1/5  bg-(--background-color) p-4 flex justify-center rounded-lg border-solid border-(--white-10)">
            Background
          </div>
        </div>
      </fieldset>
      <fieldset className="mt-4 border-dashed flex items-center rounded-[48px] border-(--white-10) border">
        <legend className="ml-12 bg-(--white-05) max-w-fit font-bold py-2 px-4 rounded-full text-(--information) mt-4">
          Grays
        </legend>
        <div className="flex flex-col w-full p-4 justify-between gap-4">
          <div className=" w-1/5  bg-(--dark-grey) text-(--white) p-4 flex justify-center rounded-lg">
            Dark grey
          </div>
          <div className=" w-1/5  bg-(--light-gray) text-(--white) p-4 flex justify-center rounded-lg">
            Light gray
          </div>
          <div className=" w-1/5  bg-(--blackish-grey) p-4 flex justify-center rounded-lg">
            Blackish-grey
          </div>
        </div>
      </fieldset>
      <fieldset className="mt-4 border-dashed flex items-center rounded-[48px] border-(--white-10) border">
        <legend className="ml-12 bg-(--white-05) max-w-fit font-bold py-2 px-4 rounded-full text-(--information) mt-4">
          Opacity Play
        </legend>
        <div className="flex flex-col w-full p-4 justify-between gap-4">
          <div className="text-(--white) w-1/5  bg-(--white-05) p-4 flex justify-center rounded-lg">
            White 5%
          </div>
          <div className=" w-1/5  bg-(--white-10) text-(--white) p-4 flex justify-center rounded-lg">
            White -10
          </div>
          <div className=" w-1/5  bg-(--white-20) text-(--white) p-4 flex justify-center rounded-lg">
            White-20
          </div>
        </div>
      </fieldset>
      <fieldset className="mt-4 border-dashed flex items-center rounded-[48px] border-(--white-10) border">
        <legend className="ml-12 bg-(--white-05) max-w-fit font-bold py-2 px-4 rounded-full text-(--information) mt-4">
          Supporting Colors
        </legend>
        <div className="flex flex-col w-full p-4 justify-between gap-4">
          <div className="bg-(--success) w-1/5  text-(--white) p-4 flex justify-center rounded-lg">
            Success
          </div>
          <div className=" w-1/5  bg-(--danger) text-(--white) p-4 flex justify-center rounded-lg">
            Danger
          </div>
          <div className=" w-1/5  bg-(--warning) text-(--white) p-4 flex justify-center rounded-lg">
            Warning
          </div>
          <div className=" w-1/5  bg-(--information) text-(--white) p-4 flex justify-center rounded-lg">
            Information
          </div>
        </div>
      </fieldset>
      <fieldset className="mt-4 border-dashed flex items-center rounded-[48px] border-(--white-10) border">
        <legend className="ml-12 bg-(--white-05) max-w-fit font-bold py-2 px-4 rounded-full text-(--information) mt-4">
          Stats Colors
        </legend>
        <div className="flex flex-col w-full p-4 justify-between gap-4">
          <div className="text-(--white) w-1/5  bg-(--fat) p-4 flex justify-center rounded-lg">
            Fat
          </div>
          <div className=" w-1/5  bg-(--protein) text-(--white) p-4 flex justify-center rounded-lg">
            Protein
          </div>
          <div className=" w-1/5  bg-(--carbs) text-(--white) p-4 flex justify-center rounded-lg">
            Carbs
          </div>
        </div>
      </fieldset>
      <fieldset className="mt-4 border-dashed flex items-center rounded-[48px] border-(--white-10) border">
        <legend className="ml-12 bg-(--white-05) max-w-fit font-bold py-2 px-4 rounded-full text-(--information) mt-4">
          Exercise Colors
        </legend>
        <div className="flex flex-col w-full p-4 justify-between gap-4">
          <div className="text-(--white) w-1/5  bg-(--squat) p-4 flex justify-center rounded-lg">
            Squat
          </div>
          <div className=" w-1/5  bg-(--bench) text-(--white) p-4 flex justify-center rounded-lg">
            Bench
          </div>
          <div className=" w-1/5  bg-(--deadlift) text-(--white) p-4 flex justify-center rounded-lg">
            Deadlift
          </div>
          <div className=" w-1/5  bg-(--deload) text-(--white) p-4 flex justify-center rounded-lg">
            Deload
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default Colors;
